<template>
  <div class="gb-zb-msg gb-zb-msg-right">{{ content.item.label }}</div>
</template>

<script>
import BaseMessage from '@/layout/messages/BaseMessage.vue'

export default {
  name: 'ContentChoosed',
  extends: BaseMessage
}

</script>

<style lang="scss" scoped>
div {
  font-weight: bold;
}
</style>
